import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProfissionalAppRoutingModule } from "./profissional.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        ProfissionalAppRoutingModule
    ]
})
export class ProfissionalAppModule { }
